import { Navigate, Route } from "react-router-dom";

import useRegulatorManager from "../../hooks/useRegulatorManager";
import { protectedElement } from "../../routing/protectedElement";
import { NAVIGATION_ROUTES } from "../../utils/NavigationUtils";
import { TRIVELTA_PRODUCTS } from "../../utils/products";
import { STAFF_REGULATORS_PATH_PREFIX } from "./staffRegulatorsRoutes";
import StaffRegulatorsApp from "./StaffRegulatorsApp";

const RegulatorManagerRoute = () => {
  const isRegulatorManager = useRegulatorManager();

  if (!isRegulatorManager) {
    return <Navigate to={NAVIGATION_ROUTES.USERS} replace />;
  }

  return protectedElement(<StaffRegulatorsApp />, {
    requiredProduct: TRIVELTA_PRODUCTS.COMPLIANCE,
    requiredProductCatalogOnly: true,
  });
};

export const staffRegulatorsAppRoute = (
  <Route
    path={`${STAFF_REGULATORS_PATH_PREFIX}/*`}
    element={<RegulatorManagerRoute />}
  />
);
